export enum Tabber {
    FBOProfile = 1,
    OrderHistory = 2,
    Autoship = 3,
    PaymentMethods = 4,
    Downline = 5,
    Tab6 = 6,
    Tickets = 7,
    Notes = 8,
    ActivityLog = 9,
    Emails = 10,
    Reports = 11

}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/tabber.ts